











































import { ValidationObserver } from 'vee-validate'
import { Component, Prop, Vue,Emit,Watch} from 'vue-property-decorator'

@Component

export default class ModalFormPassword extends Vue {
  isActive = true
  @Prop({type: Boolean, default: false}) private isLoading?: boolean
  @Prop({type: String, default: ''}) private title?: string
  @Prop({type: String, default: ''}) private message?: string
  @Prop({type: String, default: 'message.yes'}) private confirmText?: string
  @Prop({type: String, default: 'message.no'}) private cancelText?: string
  @Prop({type: String, default: ''}) private errorMessage?: string

  password = ''

  get observer(){
    return this.$refs.modalFormValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  @Watch('errorMessage')
  changeErrorMessage(newVal: string){
    console.log(newVal)
    if(newVal != ''){
      this.observer.setErrors({
        password: this.$te(newVal) ? this.$t(newVal) as string : newVal
      })
    }
  }

  created(){
    this.isActive = true
  }

  mounted(){
    //this.$refs.password.focus()
  }

    private closeModal(){
        this.$emit("onResult", {close: true});
    }

  async onConfirm(yes: boolean) {
    let password: string | false = ''
    if(yes){
      if(! await this.observer.validate()){
        return
      }
      password = this.password
    }else{
      password = false
    }
    this.$emit("onConfirm", password);
  }
}
